import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileStore } from '@lib/store';
import { cn } from '@shared/utils';
import { Addresses, UserOptions } from './widgets';
import { PageContainer, UserInfo, UserInfoHeader, View } from '@widgets';

export const ProfilePage = () => {
  const profileStore = useUnit($profileStore.store);

  const { t } = useTranslation('profile');

  return (
    <PageContainer
      className={cn('flex gap-6', (profileStore.loading || profileStore.error) && 'justify-center', 'max-[1200px]:flex-col')}
      title={t('title')}
      header={t('header')}
    >
      <View loading={profileStore.loading} error={profileStore.error} onRefresh={() => $profileStore.events.getProfile()} noData={!profileStore.data}>
        <div className='flex flex-1 flex-col gap-6'>
          <UserInfo value={profileStore.data!}>
            <UserInfoHeader user={profileStore.data!} />
          </UserInfo>
          <Addresses user={profileStore.data!} />
        </div>
        <UserOptions />
      </View>
    </PageContainer>
  );
};
